import React from 'react'
import dayjs from 'dayjs'
import '../../i18n';
import { useTranslation } from 'react-i18next';

const Summary = ({ receipt }) => {
  const { t } = useTranslation();


  return (
    <div style={{ display: 'flex', justifyContent: 'center' }}>
      <div className="summaryContainer">
        <div className="summary">
          <p><strong>{t('purchaseDate')}: </strong>{receipt ? dayjs(receipt?.timestamp).format("DD.MM.YYYY HH:mm") : null}</p>
          <p><strong>{t('cabinet')}: </strong>{receipt ? receipt.device?.name : null}</p>
        </div>


      </div>
    </div>
  )
}

export default Summary;
